import BaseService from '@src/services/BaseService'

class DailyUserRouteService extends BaseService {
    constructor() {
        super('dashboards/daily-route')
    }
}

export default new DailyUserRouteService()
